import { InjectionToken } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

export const DEVICE_DETECTOR_SERVICE = new InjectionToken<DeviceDetectorService>('device info');
